'use client';

import { SessionProvider as NextAuthSessionProvider } from 'next-auth/react';
import { createContext, useEffect, useState, useContext } from 'react';


export interface SessionProviderProps {
  children: React.ReactNode;
}

interface CartContextType {
  cartUpdatedFlag: number;
  triggerCartUpdate: () => void;
}

const CartContext = createContext<CartContextType | undefined>(undefined);

const SessionProvider = ({ children }: SessionProviderProps) => {

  const [cartUpdatedFlag, setCartUpdatedFlag] = useState(Date.now());

  const triggerCartUpdate = () => {
    //SiteHeaderの更新をtrigger
    setCartUpdatedFlag(Date.now());
  };

  return (
    <NextAuthSessionProvider>
      <CartContext.Provider value={{ cartUpdatedFlag, triggerCartUpdate }}>
        {children}
      </CartContext.Provider>
    </NextAuthSessionProvider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within SessionProvider');
  }
  return context;
};

export default SessionProvider;
